import * as config from "../config.js";

export const getUser = async (public_id, return_results = false) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! GETTING USER ID: ", public_id);

  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/user/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  if (return_results) {
    return results;
  }

  if (results.success) {
    return results.user;
  }

  return null;
};

export const sendUserEmail = async (
  public_id,
  email_address,
  subject,
  message
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_email/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      email_address: email_address,
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendGroupEmail = async (
  clientId,
  toEmails,
  userIds,
  userGroups,
  subject,
  message,
  fromEmail,
  sendAsCampaign = false,
  campaignTitle = null
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_group_email/${clientId}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      user_groups: userGroups,
      to_emails: toEmails,
      user_ids: userIds,
      subject: subject,
      message: message,
      from_email: fromEmail,
      send_as_campaign: sendAsCampaign,
      campaign_title: campaignTitle,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendUserNotification = async (public_id, subject, message) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_notification/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendGroupNotification = async (
  clientId,
  userIds,
  subject,
  message
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_group_notification/${clientId}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      user_ids: userIds,
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const saveUser = async (user, return_results = false) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));

  const method = user.public_id ? "PUT" : "POST";
  const url = user.public_id
    ? `${config.REST_SERVER_URL}/admin/user/${user.public_id}`
    : `${config.REST_SERVER_URL}/admin/user`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(user),
  });

  const results = await response.json();

  if (return_results) {
    return results;
  }

  console.log("!!! RESULTS: ", results);
  if (results.success) {
    return results.user;
  }
  return false;
};

export const deleteUser = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/user/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const createUsers = async (users) => {
  const url = `${config.REST_SERVER_URL}/admin/user/bulk_create`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ users: users }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const getEmailUsers = async () => {
  const url = `${config.REST_SERVER_URL}/admin/user/email-info`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
}

export const getUserTypes = async () => {
  const url = `${config.REST_SERVER_URL}/admin/user/user-types`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.user_types;
}

export const logoutUser = async () => {
  const url = `${config.REST_SERVER_URL}/admin/new/logout`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const loginUser = async (email, password) => {
  const url = `${config.REST_SERVER_URL}/admin/new/login`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};
